import React from 'react';
import { Trans } from 'react-i18next';
import { MenuItem, Grid, Typography } from '@mui/material';
import { BasicInput } from '@payer-admin-ui/components-v2/src/inputs/BasicInput';

type CardHeaderSizeSelectorProps = {
  availablePageSizes: number[];
  pageSize: number;
  setPageSize: (arg: number) => void;
  totalCount: number | null;
};

export const CardHeaderSizeSelector = ({
  availablePageSizes,
  pageSize,
  setPageSize,
  totalCount,
}: CardHeaderSizeSelectorProps) => {
  return (
    <Grid container alignItems="center" spacing={4}>
      <Grid item xs="auto" container spacing={1} alignItems="center">
        <Grid item>Results per page:</Grid>
        <Grid item>
          <BasicInput
            variant="outlined"
            size="small"
            value={pageSize}
            sx={{
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: theme => theme.palette.grey.A400,
                borderWidth: '1px',
              },
            }}
            InputProps={{
              sx: {
                borderRadius: '5px',
                backgroundColor: 'white',
              },
            }}
            select
            onChange={event => {
              const newSize = Number(event.target.value);
              if (newSize !== pageSize) {
                setPageSize(newSize);
              }
            }}
          >
            {availablePageSizes.map(pageSize => (
              <MenuItem key={pageSize} value={pageSize}>
                {pageSize}
              </MenuItem>
            ))}
          </BasicInput>
        </Grid>
      </Grid>
      <Grid item>
        <Typography sx={{ fontSize: '1.25rem' }} variant="subtitle2">
          {totalCount ?? '?'} <Trans i18nKey="pagination.results" />
        </Typography>
      </Grid>
    </Grid>
  );
};
